import { BadgeIcon } from '../../types/badge';

const sortBadgeIconsByPriority = (icon1: BadgeIcon, icon2: BadgeIcon) => {
  const { priority: priority1 } = icon1;
  const { priority: priority2 } = icon2;

  if (priority1 === priority2) {
    return 0;
  } else if (!priority1) {
    return 1;
  } else if (!priority2) {
    return -1;
  }

  return priority1 < priority2 ? -1 : 1;
};

const SortUtils = {
  sortBadgeIconsByPriority
};

export default SortUtils;
